import PeriodAnalysisReducer from 'store/period-analyze/reducers';

export default PeriodAnalysisReducer;
